import type { Lang } from "./types";

const supported: Lang[] = ["en", "es", "fr", "pt", "it", "de", "ar", "ru"];

export const supportedLangs = supported;
export const LANG_STORAGE_KEY = "freecrm-lang";

export function detectLang(): Lang {
  if (typeof window !== "undefined") {
    try {
      const saved = window.localStorage.getItem(LANG_STORAGE_KEY) as Lang | null;
      if (saved && supported.includes(saved)) return saved;
    } catch {
      /* ignore */
    }
  }
  if (typeof navigator === "undefined") return "en";
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language]) || [];
  for (const l of langs) {
    const code = l.toLowerCase().split("-")[0] as Lang;
    if (supported.includes(code)) return code;
  }
  return "en";
}

export function setLang(lang: Lang) {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
  window.location.reload();
}

// Pack loading lives in ./store and the React hooks in ./provider; they are
// re-exported here so components keep a single import path.
export { loadLocale, getPack } from "./store";
export { useLocale, useSections, useExtra, useLang, usePack } from "./provider";

/** Localizes labels like "17 sec". */
export function formatDuration(label: string, unit: string) {
  const n = label.match(/\d+/)?.[0];
  return n ? `${n} ${unit}` : label;
}
